import React from 'react';
import PropTypes from 'prop-types';
import {Label} from '../Label';
import {Wrapper} from '../Wrapper';

import {DesignChapter} from '@learningblocks/storybook-components';

export function Empty(props) {
  const [showOptions, setShowOptions] = React.useState(false);

  const renderMobileLayer = () => {
    return (
      <div
        onClick={() => setShowOptions(true)}
        className='mob_expStepEmpty'></div>
    );
  };

  const closeModal = () => setShowOptions(false);

  return (
    <>
      {showOptions && (
        <DesignChapter.StepOptionsModal
          onAddStep={props.onAddStep}
          list={props.options}
          isOpen={true}
          close={closeModal}
        />
      )}
      <Wrapper
        className='expStepEmpty'
        onDrop={props.onDrop}>
        <Label text={props.placeHolder} className='expStepEmpty--label' />
      </Wrapper>
      {renderMobileLayer()}
    </>
  );
}
